import { Temporal } from "@js-temporal/polyfill";

interface PlantedAgoProps {
  plantedOn: string;
}

export function PlantedAgo({ plantedOn }: PlantedAgoProps) {
  return (
    <span className="ml-1.5 text-[12px] font-normal text-ink-3">
      · {formatPlantedAgo(plantedOn)}
    </span>
  );
}

function formatPlantedAgo(plantedOn: string): string {
  const days = Temporal.PlainDate.from(plantedOn).until(Temporal.Now.plainDateISO()).days;
  if (days <= 0) return "Planted today";
  if (days === 1) return "Planted 1 day ago";
  return `Planted ${days} days ago`;
}
